<template>
    <div>
        <site-header></site-header>
        <div class="c-t-search">
            <div class="c-t-search__header">
                <search-header></search-header>
            </div>

            <div class="c-t-search__main-wrap">
                <div class="c-t-search__sidebar">
                    <search-sidebar></search-sidebar>
                </div>
                <div class="c-t-search__main">
                    <search-results></search-results>
                </div>
            </div>

        </div>
        <div class="c-t-search__footer">
            <site-footer></site-footer>
        </div>
    </div>
</template>


<script>
    import { mapActions } from 'vuex';
    import { FETCH_REQUESTS } from '../store/store-models/requests-model';

    import SiteHeader from './components/organisms/OrganismSiteHeader.vue'
    import SiteFooter from './components/organisms/OrganismSiteFooter.vue'
    import SearchHeader from './components/organisms/search/OrganismSearchHeaderRequests.vue'
    import SearchResults from './components/organisms/search/OrganismSearchResultsRequests.vue'
    import SearchSidebar from './components/organisms/search/OrganismSearchSidebarRequests.vue'
    import Pagination from './components/molecules/MoleculePagination.vue';

    export default {
        components: {
            SiteHeader,
            SiteFooter,
            SearchHeader,
            SearchResults,
            SearchSidebar,
            Pagination
        },
        methods: {
            ...mapActions({
                fetchRequests: FETCH_REQUESTS
            }),
        },
        created() {
            this.fetchRequests();
        },
        metaData () {
            return {
                title: 'Sök förfrågan',
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: 'Här kan du söka och titta på andra förfrågningar som liknar din egen. Du kan även se vad man har budgeterat i snitt för liknande uppdrag i din kommun och allmänna budgetråd för byggprojekt.'
                    }
                ],
                link: [
                        {rel: 'canonical', href: `${process.env.SITE_BASE_URL}${this.$route.path}`}
                ],
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/Requests.vue